import type { Match } from '@ubs/rules';

/**
 * Yarım kalan yerel maçın diske yazılması.
 *
 * Uygulama ana ekrana kurulduğunda (PWA) arka plana alınan sekme işletim
 * sistemi tarafından öldürülebiliyor; geri dönüldüğünde sayfa sıfırdan
 * yükleniyor ve bellekteki maç yok oluyordu. `Match` düz bir nesne — JSON'a
 * olduğu gibi çeviriliyor, geri okununca kural motoru kaldığı yerden devam
 * ediyor.
 *
 * Yalnızca BOTLARA KARŞI oyun için: online masanın durumu zaten sunucuda ve
 * oraya yeniden bağlanmak koltuğu geri veriyor.
 */

const KEY = 'ubs:local-game';

export interface SavedGame {
  name: string;
  seed: string;
  match: Match;
  botMoves: number[];
}

export function saveLocal(game: SavedGame): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(game));
  } catch {
    /* depolama kapalıysa oyun yalnızca bellekte yaşar */
  }
}

/** Yarım kalmış maç varsa döner. Biten maç kayıt sayılmıyor. */
export function loadLocal(): SavedGame | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SavedGame>;
    const match = parsed.match;
    // Kayıt bozuksa ya da maç bitmişse devam edilecek bir şey yok.
    if (!match || !match.deal || match.phase === 'matchOver') return null;
    return {
      name: parsed.name ?? 'Sen',
      seed: parsed.seed ?? match.seed,
      match,
      botMoves: parsed.botMoves ?? [0, 0, 0],
    };
  } catch {
    return null;
  }
}

export function clearLocal(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* yoksa zaten temiz */
  }
}
